import React from "react";
import { useLang, CONTACT } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="relative border-t border-border bg-surface py-16">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_reformas-acero/artifacts/x4bhwdrh_WhatsApp%20Image%202026-08-09%20at%2022.00.56.jpeg"
              alt="Acero Construcciones y Reformas"
              className="h-14 w-auto object-contain mb-5"
            />
            <p className="text-steel-400 max-w-xs leading-relaxed">{f.tagline}</p>
          </div>
          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-brand-orange mb-5">{f.services}</div>
            <div className="grid grid-cols-2 gap-2 text-sm text-steel-300">
              {t.servicios.items.slice(0, 8).map((s, i) => (
                <button key={i} onClick={() => go("servicios")} className="text-left hover:text-white transition-colors">{s.t}</button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-brand-orange mb-5">{f.contact}</div>
            <div className="space-y-2 text-sm text-steel-300">
              <a href={`tel:${CONTACT.whatsapp}`} className="block hover:text-white transition-colors">{CONTACT.phoneDisplay}</a>
              <a href={`mailto:${CONTACT.email}`} className="block hover:text-white transition-colors">{CONTACT.email}</a>
              <div>{CONTACT.city}</div>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-border text-xs text-steel-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Acero Construcciones y Reformas. {f.rights}</span>
          <span>Construimos con experiencia. Reformamos con excelencia.</span>
        </div>
      </div>
    </footer>
  );
}
